
import { useParams } from 'react-router-dom';
import { OfertasCabFormState } from '../../../context/ofertascab/OfertasCabFormState';
import { Form } from './form';

export const OfertasCabFormPage = () => {
  const { id } = useParams();
  const title = id ? "Editar Oferta":"Crear Oferta";

  return (
    <OfertasCabFormState>
         <br />
        <Form title={title} />
    </OfertasCabFormState>
  );
};
